
<div class="dashboard-main-wrapper">

  <div class="dashboard-header">
    
    
</div>
<!-- <mat-toolbar class="example-toolbar"> -->
  <!-- <mat-icon (click)="change_nav()" >menu</mat-icon> -->
  
  <!-- <span class="example-fill-remaining-space"></span>
</mat-toolbar> -->

    <app-sidebar [isExpanded]="isExpanded"></app-sidebar>
    <div class="dashboard-wrapper {{isExpanded? 'close-nav' : klass_nav}}">
        <nav class="navbar navbar-expand-lg bg-white sticky-top">
            <!-- <a class="navbar-brand" href="#"><img src="assets/images/logo.png" class="img-fluid" alt=""></a> -->
            <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                >
                <span class="navbar-toggler-icon"></span>
            </button> -->
            <div (click)="change_nav()" class="slider-menu">
                <mat-icon>chevron_left</mat-icon>
            </div>
            
                <ul class="navbar-nav ml-auto navbar-right-top">
                    <li class="nav-item dropdown nav-user">
                        <a class="nav-link nav-user-img d-flex align-items-center justify-content-between" href="#"
                            id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div class="nav-user-info">
                                <h5 class="mb-0  nav-user-name">{{restroName}} </h5>
                                <span class="status"></span><span>Available</span>
                            </div>
                            <img src={{logoIMage}} alt="" class="user-avatar-md rounded-circle">
                            <mat-icon>expand_more</mat-icon>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right nav-user-dropdown"
                            aria-labelledby="navbarDropdownMenuLink2"
                            [style.display]="sidebarVisible? 'block' : 'd-lg-none'">
                            <a class="dropdown-item"  routerLinkActive="active" routerLink="/update-password" ><i class="fas fa-user mr-2"></i>Account</a>
                            <!-- <a class="dropdown-item" href="#"><i class="fas fa-cog mr-2"></i>Setting</a> -->
                            <a class="dropdown-item" (click)="closseFunction()" style="cursor: pointer;"><i
                                class="fas fa-power-off mr-2"></i>Logout</a>
                        </div>
                    </li>
                </ul>
        </nav> 
        <router-outlet></router-outlet>
  
    

<app-footer></app-footer>
</div>
  </div>
  
 <!-- <div class="example-container">
    <mat-toolbar class="example-toolbar">
      <mat-icon (click)="change_nav()" >menu</mat-icon>
      
      <span class="example-fill-remaining-space"></span>
  </mat-toolbar>

  <mat-sidenav-container class="example-sidenav-container" autosize>
    <app-sidebar></app-sidebar>
      <div class="example-sidenav-content no-nav layout">
          <router-outlet></router-outlet>
      </div>
  </mat-sidenav-container>

</div> 
<app-footer></app-footer> -->
